<template>
	<div :name="`name${data.qid}`" class="test_question list">
		<div
			class="title"
			:style="{
				fontSize: bandingstyle.appearance.fontStemSize + 'px',
				color: bandingstyle.appearance.fontStemColor,
				fontWeight: bandingstyle.appearance.fontStemBold,
				fontStyle: bandingstyle.appearance.fontStemItalic,
				textDecoration: bandingstyle.appearance.fontStemUnderline
			}"
		>
			<span v-if="data.mustanswer" class="required"></span>
			<HtmlClickImgEnlarge :content="data.questionsName" />
		</div>

		<div  v-if="data.questionsSonList.length > 0" class="input_box">
			<div style="max-width: 1100px;height:auto; overflow-x: auto;">
				<!-- 正常显示 -->
				<table style="margin-top:10px;" v-if="data.lineRankExchange == false">
					<tr>
						<td class="td_width"></td>
						<td class="td_width" v-for="(option, index2) in data.questionsSonList[0].optionList" :key="index2">
							<div style="width: 150px;"><HtmlClickImgEnlarge :content="option.labelName" /></div>
						</td>
					</tr>
					<tr v-for="(item2, index) in data.questionsSonList" :key="item2.SonId + index">
						<td class="td_width">
							<div style="width: 150px;"><HtmlClickImgEnlarge :content="item2.questionsName" /></div>
						</td>
						<td
							class="td_width"
							:class="{ 'padding-10': data.questionsTypeId == '21' || data.questionsTypeId == '22' ? true : false }"
							v-for="(option, index3) in item2.optionList"
							:key="index + '-' + index3"
						>
							<template v-if="data.questionsTypeId == '19' || data.questionsTypeId == '20'">
								<el-radio v-if="data.questionsTypeId == '19'" type="radio" v-model="item2.isSelected" :label="option.oid" @change="changeRadio"></el-radio>
								<el-checkbox
									v-else-if="data.questionsTypeId == '20'"
									type="checkbox"
									v-model="option.isSelected"
									:label="option.oid"
									@change="changeRadio"
								></el-checkbox>
								<input
									type="text"
									@input="haveInputInput(option)"
									:class="{ input__err: option.validate }"
									v-model="option.inputValue"
									v-if="option.haveInput"
									style="border: 1px solid #ccc;width: 60px;"
									@blur="changeRadio"
								/>
							</template>
							<template v-else-if="data.questionsTypeId == '21'">
								<ul class="ul_rate" :option="option.oid">
									<li v-for="(n, rateIndex) in data.highestScore" :key="option.oid + '-' + rateIndex" @click="ratingScore(n, option)">
										<img v-if="rateIndex < option.ratingScore" :src="xinga" alt="" />
										<img v-if="rateIndex >= option.ratingScore" :src="xingb" alt="" />
									</li>
								</ul>
							</template>
							<template v-else-if="data.questionsTypeId == '22'">
								<input
									type="text"
									:class="{ input__err: option.validate }"
									v-model="option.userAnswer"
									class="Rectinput"
									@blur="completionBlur"
								/>
							</template>
							<template v-else-if="data.questionsTypeId == '39'">
								<el-radio 
									v-if="option.type == '26'"
									type="radio" 
									v-model="item2.userAnswer"
									:label="option.oid"
									@change="completionBlur"
									:disabled="item2.disable"
								></el-radio>
								<el-select
									:popper-append-to-body="false"
									size="small"
									:placeholder="$t('UserAnswer.PleaseSelect')"
									v-else-if="option.type == '10'"
									:class="{ input__err: option.validate }"
									class="Rectselect"
									v-model="option.userAnswer"
									@change="completionBlur"
									:disabled="item2.disable"
								>
									<el-option v-for="info in option.options" :key="info.value" :label="info.label" :value="info.label">
										<HtmlClickImgEnlarge :content="info.label" />
									</el-option>
								</el-select>

								<el-upload
									v-else-if="option.type == '12'"
									class="upload-demo"
									ref="upload"
									:action="$config.service.uploadApi"
									:data="qn"
									:auto-upload="true"
									:limit="1"
									:before-upload="beforeFileUpload"
									:on-remove="(file, fileList) => handleRemove(file, fileList, option)"
									:on-success="(response, file, fileList) => handleSuccess(response, file, fileList, 1, option)"
									:on-error="(err, file, fileList) => handleerror(err, file, fileList, option)"
									:on-exceed="(files, fileList) => handleexceed(files, fileList, option)"
									:file-list="option.fileList"
									:multiple="true"
									@change="userAnswerChange"
									:disabled="item2.disable"
								>
									<el-button style="width: 100%;height:43px;background:#fff;color:#333" type="primary">
										<img src="@/assets/uploadfile.png" style="margin-right:10px" :alt="$t('UserAnswer.UploadFileImages')" />
										{{$t('UserAnswer.UploadFilesWithin10M')}}
									</el-button>
								</el-upload>

								<el-input
								 type="textarea"
									v-else-if="option.type == '1'"
									:class="{ input__err: option.validate }"
									v-model="option.userAnswer"
									class="Rectinput"
									@blur="completionBlur"
									:disabled="item2.disable"
								></el-input>

								<input
									v-else
									type="text"
									:class="{ input__err: option.validate }"
									v-model="option.userAnswer"
									class="Rectinput"
									@blur="completionBlur"
									:disabled="item2.disable"
								/>
							</template>
						</td>
					</tr>
				</table>

				<table style="margin-top:10px;" v-else>
					<tr>
						<td class="td_width"></td>
						<td class="td_width" v-for="(option, index2) in data.questionsSonList" :key="index2">
							<div style="width: 150px;"><HtmlClickImgEnlarge :content="option.questionsName" /></div>
						</td>
					</tr>
					<tr v-for="(item2, index) in data.questionsSonList[0].optionList" :key="item2.oid + index">
						<td class="td_width">
							<div style="width: 150px;"><HtmlClickImgEnlarge :content="item2.labelName" /></div>
						</td>
						<td
							class="td_width"
							:class="{ 'padding-10': data.questionsTypeId == '21' || data.questionsTypeId == '22' ? true : false }"
							v-for="subquestion in data.questionsSonList"
							:key="subquestion.SonId + 'subquestion'"
						>
							<template v-if="data.questionsTypeId == '19' || data.questionsTypeId == '20'">
								<el-radio
									v-if="data.questionsTypeId == '19'"
									type="radio"
									v-model="subquestion.isSelected"
									:label="subquestion.optionList[index].oid"
									@change="changeRadio"
								></el-radio>
								<el-checkbox
									v-else-if="data.questionsTypeId == '20'"
									type="checkbox"
									v-model="subquestion.optionList[index].isSelected"
									:label="subquestion.optionList[index].oid"
									@change="changeRadio"
								></el-checkbox>
								<input
									@input="haveInputInput(subquestion.optionList[index])"
									:class="{ input__err: subquestion.optionList[index].validate }"
									type="text"
									v-model="subquestion.optionList[index].inputValue"
									v-if="subquestion.optionList[index].haveInput"
									style="border: 1px solid #ccc;width: 60px;"
									@blur="changeRadio"
								/>
							</template>
							<template v-else-if="data.questionsTypeId == '21'">
								<ul class="ul_rate" :option="subquestion.optionList[index].oid">
									<li
										v-for="(n, rateIndex) in data.highestScore"
										:key="subquestion.optionList[index].oid + '-' + rateIndex"
										@click="ratingScore(n, subquestion.optionList[index])"
									>
										<img v-if="rateIndex < subquestion.optionList[index].ratingScore" :src="xinga" alt="" />
										<img v-if="rateIndex >= subquestion.optionList[index].ratingScore" :src="xingb" alt="" />
									</li>
								</ul>
							</template>
							<template v-else-if="data.questionsTypeId == '22'">
								<input
									type="text"
									:class="{ input__err: subquestion.optionList[index].validate }"
									v-model="subquestion.optionList[index].userAnswer"
									class="Rectinput"
									@blur="completionBlur"
								/>
							</template>

							<template v-else-if="data.questionsTypeId == '39'">
								<el-radio 
									v-if="subquestion.type == '26'"
									type="radio" 
									:label="item2.oid"
									@change="completionBlur"
									v-model="subquestion.userAnswer"
									:disabled="subquestion.disable"
								></el-radio>
								<el-select
									:popper-append-to-body="false"
									size="small"
									:placeholder="$t('UserAnswer.PleaseSelect')"
									v-if="subquestion.optionList[index].type == '10'"
									:class="{ input__err: subquestion.optionList[index].validate }"
									class="Rectselect"
									v-model="subquestion.optionList[index].userAnswer"
									@change="completionBlur"
									:disabled="subquestion.disable"
								>
									<el-option v-for="info in subquestion.optionList[index].options" :key="info.value" :label="info.label" :value="info.label">
										<HtmlClickImgEnlarge :content="info.label" />
									</el-option>
								</el-select>

								<el-upload
									v-else-if="subquestion.optionList[index].type == '12'"
									class="upload-demo"
									ref="upload"
									:action="$config.service.uploadApi"
									:data="qn"
									:auto-upload="true"
									:limit="1"
									:before-upload="beforeFileUpload"
									:on-remove="(file, fileList) => handleRemove(file, fileList, subquestion.optionList[index])"
									:on-success="(response, file, fileList) => handleSuccess(response, file, fileList, 1, subquestion.optionList[index])"
									:on-error="(err, file, fileList) => handleerror(err, file, fileList, subquestion.optionList[index])"
									:on-exceed="(files, fileList) => handleexceed(files, fileList, subquestion.optionList[index])"
									:file-list="subquestion.optionList[index].fileList"
									:multiple="true"
									:disabled="subquestion.disable"
								>
									<el-button style="width: 100%;height:43px;background:#fff;color:#333" type="primary">
										<img src="@/assets/uploadfile.png" style="margin-right:10px" :alt="$t('UserAnswer.UploadFileImages')" />
										{{$t('UserAnswer.UploadFilesWithin10M')}}
									</el-button>
								</el-upload>

								<el-input
									type="textarea"
									v-else-if="subquestion.optionList[index].type == '1'"
									:class="{ input__err: subquestion.optionList[index].validate }"
									v-model="subquestion.optionList[index].userAnswer"
									class="Rectinput"
									@blur="completionBlur"
									:disabled="subquestion.disable"
								></el-input>

								<input
									v-else
									type="text"
									:class="{ input__err: subquestion.optionList[index].validate }"
									v-model="subquestion.optionList[index].userAnswer"
									class="Rectinput"
									@blur="completionBlur"
									:disabled="subquestion.disable"
								/>
							</template>
						</td>
					</tr>
				</table>
			</div>
			<!-- sum 逻辑添加结果说明 -->
			<div 
				v-if="data.tip" 
				style="font-size: 14px;margin-top: 5px;"
			>{{ data.tip }}</div>

			<div v-show="data.validate" class="form-item__error">{{ data.validateMsg }}</div>
		</div>
	</div>
</template>

<script>
import HtmlClickImgEnlarge from '@/components/myComponents/htmlClickImgEnlarge.vue';
export default {
	components: {
		HtmlClickImgEnlarge
	},
	name: 'MatrixTypePC',
	props: {
		data: {},
		bandingstyle: {}
	},
	data() {
		return {
			qn: {
				biz: 'upDataWj',
				data: {}
			},
			answerArr: [],
			optioArr: [],
			xinga: require('@/assets/default-imgs/stars_1.png'), //亮星星
			xingb: require('@/assets/default-imgs/stars_2.png') //暗星星
		};
	},
	created() {
		if (this.data.questionsTypeId == '22' || this.data.questionsTypeId == '39') {
			this.completionBlur();
		}
	},
	methods: {
		handleSuccess(response, file, fileList, num, option) {
			// console.log(option);
			// console.log(this.data.userAnswer);
			option.userAnswer = [];
			this.data.userAnswer = [];
			let tempFileList = JSON.parse(JSON.stringify(fileList));
			// console.log(tempFileList);
			tempFileList.forEach(info => {
				// console.log(info);
				if (info.status === 'success') {
					option.userAnswer.push(info.response.message);
					this.data.userAnswer.push(info.response.message);
				}
			});
			option.fileList = fileList;
			this.data.fileList = fileList;
			this.userAnswerChange();
			this.completionBlur();
			// console.log(this.data.fileList)
			// console.log(this.data.userAnswer);
		},
		beforeFileUpload(file) {
			let size = file.size / 1024 / 1024 < 10; //这里做文件大小限制
			if (!size) {
				this.$message({
					message: this.$t('UserAnswer.TheFileSizeCannotExceed10MB'),
					type: 'warning'
				});
				return size;
			}
			this.qn.data = file;
		},
		//选择上传文件
		handleRemove(file, fileList, option) {
			let arr = [];
			option.userAnswer = [];
			this.data.userAnswer = [];
			if (fileList.length > 0) {
				fileList.forEach(info => {
					option.userAnswer.push(info.response.message);
					this.data.userAnswer.push(info.response.message);
					let y = info.response.message.split('upDataWj/')[1];
					arr.push({
						name: y
					});
				});
			}
			option.fileList = arr;
			this.data.fileList = arr;
			this.completionBlur();
			this.userAnswerChange();
		},
		handleexceed(files, fileList) {
			this.$message({
				message: this.$t('UserAnswer.MaximumNumberOfTimes'),
				type: 'warning'
			});
		},
		handleerror(err, file, fileList, item) {
			this.$message({
				message: this.$t('UserAnswer.FailedToUploadFile'),
				type: 'warning'
			});
		},
		haveInputInput(option) {
			if (option.isMaxNum && option.inputValue.length > option.maxNum) {
				option.inputValue = option.inputValue.substring(0, option.maxNum - 1);
			}
		},
		userAnswerChange() {
			console.log('触发了');
			this.$emit('userAnswerChange', this.data);
		},
		changeRadio() {
			this.data.userAnswerArr = [];
			this.data.questionsSonList.forEach((info, index) => {
				let valueObj = {
					SonId: info.SonId,
					value: ''
				};
				let arr = [];
				info.optionList.forEach(el => {
					// console.log(el)
					switch(this.data.questionsTypeId) {
						case '19':
							// 单选
							if (info.isSelected == el.oid) {
								if (el.inputValue) {
									valueObj.value = `${info.isSelected}:${el.inputValue}`;
								} else {
									valueObj.value = `${info.isSelected}`;
								}
							}
							// console.log(`valueObj.value` )
							// console.log(valueObj.value )
							break;
						case '20':
							// 多选
							if (el.isSelected) {
								if (el.inputValue) {
									arr.push(`${el.oid}:${el.inputValue}`);
								} else {
									arr.push(el.oid);
								}
							}
							valueObj.value = arr.join(',');
						break;
					}
				});
				if (info.SonId == valueObj.SonId) {
					this.data.userAnswerArr[index] = valueObj;
				}
			});
			this.userAnswerChange();
		},
		ratingScore(n, opt) {
			this.data.userAnswerArr = [];
			opt.ratingScore = n;
			this.data.questionsSonList.forEach((info, index) => {
				let valueObj = {
					SonId: info.SonId,
					optionValue: []
				};
				let arr = [];
				info.optionList.forEach(el => {
					arr.push({
						oid: el.oid,
						value: el.ratingScore
					});
					valueObj.optionValue = arr;
				});
				if (info.SonId == valueObj.SonId) {
					this.data.userAnswerArr[index] = valueObj;
				}
			});
			this.userAnswerChange();
		},
		completionBlur() {
			this.userAnswerChange();
			this.data.userAnswerArr = [];
			this.data.questionsSonList.forEach((info, index) => {
				let valueObj = {
					SonId: info.SonId,
				}
					let arr = [];
					info.optionList.forEach((el, j) => {
						if (info.type == '26') {
							if (info.userAnswer == el.oid) {
								arr.push({
									oid: el.oid,
									value: 1
								});
							} else {
								arr.push({
									oid: el.oid,
									value: ''
								});
							}
						} else {
							console.log('el.userAnswer :>> ', el.userAnswer);
							arr.push({
								oid: el.oid,
								value: el.userAnswer
							});
						}
					});
					valueObj.optionValue = arr;
				if (info.SonId == valueObj.SonId) {
					this.data.userAnswerArr[index] = valueObj;
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.test_question {
	.option-box {
		display: flex;
		flex-direction: column;
		padding-left: 25px;
		.option + .option {
			margin-top: 10px;
		}
	}
}
.list {
	margin-top: 50px;
	.multiple {
		padding-left: 10px;
		.item-title {
			font-size: 14px;
			margin-bottom: 15px;
		}
	}
	.multiple + .multiple {
		margin-top: 20px;
	}
	.stem {
		padding-left: 10px;
		font-size: 14px;
		line-height: 30px;
	}
}
.required::before {
	content: '*';
	color: #f56c6c;
	margin-right: 4px;
}
.form-item__error {
	color: #f56c6c;
}
/deep/.input__err > .el-textarea__inner {
	border-color: #f56c6c;
}

/deep/.input__err > .el-input > .el-input__inner {
	border-color: #f56c6c;
}
/deep/.el-radio,
/deep/.el-checkbox {
	padding: 10px;
	width: 100%;
	box-sizing: border-box;
	.el-radio__label,
	.el-checkbox__label {
		display: none;
	}
}
.input_box {
	width: 50%;
	display: inline-block;
}
.input_box-border {
	display: inline-block;
}
.padding-10 {
	padding: 10px;
}
table,
table th,
table tr:first-child td {
	padding: 10px;
}
table,
table td,
table th {
	border: 1px solid #ccc;
	border-collapse: collapse;
	text-align: center;
	font-size: 14px;
}
.td_width {
	padding: 10px 15px;
}
.ul_rate {
	display: flex;
	justify-content: space-around;
}
.Rectinput {
	width: 120px;
	// height: 20px;
	border: 1px solid #ccc;
}

.input_box {
	width: 100%;
}
.input__err {
	border-color: #f56c6c !important;
}
</style>
